// Escalation thresholds for the "update available" prompt (UpdateAvailableNotification).
// A tab that keeps dismissing the prompt, or sits on a stale build for a day,
// is escalated to a blocking modal + forced reload — the last resort for an
// actively-used tab the safe-boundary auto-reload (useUpdateEnforcer) never
// caught because it was never hidden or idle.

export const RESURFACE_MS = 30 * 60 * 1000; // re-show 30 min after a dismissal
export const HARD_ESCALATION_MS = 24 * 60 * 60 * 1000; // 24h stale → blocking modal
export const MAX_DISMISSALS = 3; // 3 dismissals → blocking modal
export const COUNTDOWN_SECONDS = 60; // modal countdown before forced reload

/**
 * Whether the prompt should hard-escalate to the blocking modal: the user has
 * dismissed it `MAX_DISMISSALS` times, or the build has been stale for
 * `HARD_ESCALATION_MS`.
 *
 * @param {number} dismissCount - times the prompt has been dismissed.
 * @param {number|null} firstDetectedAt - epoch ms of first update detection.
 * @param {number} now - current epoch ms.
 */
export function shouldHardEscalate(dismissCount, firstDetectedAt, now) {
  if (dismissCount >= MAX_DISMISSALS) return true;
  if (firstDetectedAt != null && now - firstDetectedAt >= HARD_ESCALATION_MS) {
    return true;
  }
  return false;
}
